/**
 * Generated today date
 */
export const getTodayDate = (): Date => new Date();
